import uniqid from 'uniqid'
import { projects } from '../../portfolio'
import ProjectCard from '../ProjectCard/ProjectCard'
import './Projects.css'

const Projects = () => {
  if (!projects.length) return null

  return (
    <section id='projects' className='section projects'>
      <h2 style={{ color: "var(--clr-primary)" }} className='section__title'>Featured Projects</h2>

      <div className='projects__grid'>
        {projects.map((project) => (
          <ProjectCard key={uniqid()} project={project} />
        ))}
      </div>

      <div className='github-section'>
        <i>
          Check out my{' '}
          <a href='https://github.com/ShujaatAzim' target='_blank'>
            GitHub
          </a>{' '}
          for more of my work!
        </i>
      </div>
    </section>
  );
}

export default Projects
